export default __webpack_public_path__ + "static/media/gitlab.d798e513.png";